module.exports = __webpack_public_path__ + "img/41ne.2f855b31.svg";